/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { Component } from 'react';
import * as Styles from './index.style';
import { get } from 'lodash';
import {
  storeLogosContainerCss,
  storeLinkCss,
  storeLogoCss,
} from './index.style';
export default class DownloadApp extends Component {
  render() {
    const { isDarkMode, fields } = this.props;
    const Title = get(fields, 'fields.Title.value', '');
    const Subtitle = get(fields, 'fields.Subtitle.value', '');
    const LeftButtonLink = get(fields, 'fields.LeftButtonLink.value.href', '');
    const RightButtonLink = get(
      fields,
      'fields.RightButtonLink.value.href',
      '',
    );
    const LeftButtonImage = get(fields, 'fields.LeftButtonImage.value.src', '');
    const RightButtonImage = get(
      fields,
      'fields.RightButtonImage.value.src',
      '',
    );
    console.log('zz Download App>>>>', fields);
    return (
      <div
        css={[
          Styles.commonCss,
          isDarkMode ? Styles.DarkModeCss : Styles.LightModeCss,
        ]}
      >
        <h3>{Title}</h3>
        <p className="app_txt">{Subtitle}</p>
        <div css={storeLogosContainerCss}>
          <a
            css={storeLinkCss}
            href={LeftButtonLink}
            key={`download-logo-1`}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img src={LeftButtonImage} css={storeLogoCss} />
          </a>
          <a
            css={storeLinkCss}
            href={RightButtonLink}
            key={`download-logo-2`}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img css={storeLogoCss} src={RightButtonImage} />
          </a>
        </div>
      </div>
    );
  }
}
